<template>
  <TextInput :type="showPassword ? 'text' : 'password'">
    <template v-if="showPasswordButton" #button>
      <button @click="showPassword = !showPassword">
        {{ t("components.buttons.show") }}
      </button>
    </template>
  </TextInput>
</template>

<script setup>
import { TextInput } from ".";
import { ref } from "vue";
import { useI18n } from "vue-i18n";
defineProps({
  showPasswordButton: {
    type: Boolean,
    default: true,
  },
});
const { t } = useI18n();

const showPassword = ref(false);
</script>
